import * as React from "react";
const SvgValuePropListItemIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}) => <svg {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby={titleId} aria-describedby={descId}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<rect x={0.5} y={0.5} width={19} height={19} rx={9.5} stroke="#A6CDDC" /><path d="M14.6875 6.5L8.5 13.25L5.6875 10.1818" stroke="#A6CDDC" strokeLinecap="square" /></svg>;
export default SvgValuePropListItemIcon;